// @ts-check
/**
 * The one place WhatsApp colours, fonts and shapes live. Components read from here (inline styles for
 * colours) so nothing else in the admin types a WhatsApp hex value.
 */
export const whatsappTheme = Object.freeze({
  colors: Object.freeze({
    wallpaper: '#EFEAE2',
    outgoingBubble: '#D9FDD3',
    incomingBubble: '#FFFFFF',
    header: '#008069',
    headerText: '#FFFFFF',
    headerSubtext: '#D1F4EC',
    avatar: '#DFE5E7',
    panel: '#F0F2F5',
    textPrimary: '#111B21',
    textSecondary: '#667781',
    readTick: '#53BDEB',
    link: '#00A5F4',
    error: '#EA0038',
    frame: '#111B21',
    separatorPill: '#FFFFFF',
  }),
  fontFamily: '"Segoe UI", "Helvetica Neue", Helvetica, Arial, sans-serif',
  bubbleRadius: '7.5px',
});
